import React from 'react';
import { Grid, Chip, Tooltip } from '@material-ui/core';
import EnergyTooltip from './materialTypeComponents/EnergyTooltip';

// Purchase list shows one chip per material type ("Feed", "Medicine") instead of one per item ("L1 Feed",
// "L2 Feed"); the item names of each type are in the chip's tooltip.
export const groupByMaterialType = (purchaseMaterials, materialTypes) => {
    const groups = [];
    (purchaseMaterials || []).forEach(material => {
        const materialType = (materialTypes || []).find(type => type.id === material.materialTypeId);
        const typeName = materialType ? materialType.materialType : material.materialName;
        const group = groups.find(g => g.typeName === typeName);
        if (group) {
            if (!group.itemNames.includes(material.materialName)) {
                group.itemNames.push(material.materialName);
            }
        } else {
            groups.push({ typeName, itemNames: [material.materialName] });
        }
    });
    return groups;
};

export const matchesMaterialSearch = (term, purchaseMaterials, materialTypes) => {
    const search = term.toLowerCase();
    return groupByMaterialType(purchaseMaterials, materialTypes).some(group =>
        group.typeName.toLowerCase().includes(search) ||
        group.itemNames.some(name => name.toLowerCase().includes(search))
    );
};

const MaterialTypeChip = ({ group }) => (
    <Grid item>
        <Tooltip arrow title={group.itemNames.join(', ')}>
            <Chip label={group.typeName} color="primary" size='small' />
        </Tooltip>
    </Grid>
);

const MaterialTypeChips = ({ purchaseMaterials, materialTypes, maxChips }) => {
    const groups = groupByMaterialType(purchaseMaterials, materialTypes);
    const visible = groups.slice(0, maxChips);
    const hidden = groups.slice(maxChips);
    return (
        <>
            {visible.map(group => <MaterialTypeChip key={group.typeName} group={group} />)}
            {hidden.length > 0 ?
                <EnergyTooltip
                    arrow={true}
                    title={
                        <Grid container spacing={1}>
                            {hidden.map(group => <MaterialTypeChip key={group.typeName} group={group} />)}
                        </Grid>
                    }
                >
                    <Grid item>
                        <Chip size="small" color="primary" label={`+ ${hidden.length}`} />
                    </Grid>
                </EnergyTooltip> : ""
            }
        </>
    );
};

export default MaterialTypeChips;
